import React, {useEffect, useState} from 'react';
import {Input, Typography} from 'antd';
import {Block} from './block';
import {isUndefined} from 'lodash';
import classnames from 'classnames';

export function TextEditor({editedValue, handleValue, placeholder}) {
    return <Input value={editedValue} onChange={handleValue} placeholder={placeholder} />;
}

export function TextBlock({debug, className, value, placeholder, hiddenValue, onCancel, onSave, onValue, delegatedEditMode}) {
    const [editMode, setEditMode] = useState();
    const [editedValue, setEditedValue] = useState();
    const classes = classnames('textBlock', className);

    useEffect(() => {
        if (!isUndefined(delegatedEditMode)) {
            setEditMode(delegatedEditMode);
        }
    }, [delegatedEditMode]);

    useEffect(() => {
        setEditedValue(value);
    }, [value]);

    const handleValue = (e) => {
        setEditedValue(e.target.value);
        onValue && onValue(e.target.value);
    };

    const handleSave = () => {
        setEditMode(false);
        onSave && onSave(editedValue);
    };

    const handleCancel = () => {
        setEditMode(false);
        setEditedValue(value);
        onCancel && onCancel();
    };

    function onEdit() {
        if (isUndefined(delegatedEditMode)) {
            setEditMode(true);
        }
    }

    return (
        <Block debug={debug} className={classes} onEdit={onEdit} onCancel={handleCancel} onSave={handleSave} delegatedEditMode={delegatedEditMode}>
            {!editMode && value && !hiddenValue && <Typography.Text className="textValue">{value}</Typography.Text>}
            {editMode && <TextEditor editedValue={editedValue} handleValue={handleValue} placeholder={placeholder} />}
        </Block>
    );
}
